import { render, staticRenderFns } from "./Phone.vue?vue&type=template&id=892199d0&scoped=true&"
import script from "./Phone.vue?vue&type=script&lang=js&"
export * from "./Phone.vue?vue&type=script&lang=js&"
import style0 from "./Phone.vue?vue&type=style&index=0&id=892199d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "892199d0",
  null
  
)

export default component.exports